export const normalizeAccessToken = (token: string | null | undefined): string | undefined => {
  if (!token) return undefined;
  const trimmed = token.trim();
  if (!trimmed) return undefined;

  // Some backends return "Bearer <jwt>". We only persist the raw JWT in cookies.
  const withoutBearer = trimmed.replace(/^Bearer\s+/i, '');
  return withoutBearer.trim() || undefined;
};
